import React from "react";
import {
  BankSelectContent,
  useImportBankSelect,
} from "@features/bankSelect/components/BankSelect";

interface BankImportBlockProps {
  onBack: () => void;
}

export const BankImportBlock = ({ onBack }: BankImportBlockProps) => {
  const { banks, isFetching, searchValue, onChange, onSelect } =
    useImportBankSelect();

  return (
    <BankSelectContent
      banks={banks}
      isFetching={isFetching}
      searchValue={searchValue}
      onChange={onChange}
      onSelect={onSelect}
      onClose={onBack}
    />
  );
};
